import React, {Component} from "react";  
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import axios from "axios";
import {Link} from "react-router-dom";
import Switch from "react-switch";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
class OkrReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            okrLists:[]
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });

        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {

            this.get_okr_report();

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            var merchantData = [{"value":decoded.object_code, "label":""}]
            //this.changeMerchant(merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.get_okr_report();
        }
        else if(decoded.object_type=='Chain') {
            //this.getStore(decoded.object_code, 'chain', decoded.object_type, decoded.object_code);
            var chainData = [{"value":decoded.object_code, "label":""}]
            //this.changeChain(chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.get_okr_report();
        }
        else if(decoded.object_type=='Store') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            //this.changeStore(storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
            this.get_okr_report();
        }
     
        else {
            this.unauthorize_access();
        }

    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("support_module")===false || reportPermissions.includes("user_login")===false ){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }



    get_okr_report() {
        axios.post(config.get('API_URL') + '/reports/okr-report', {

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            console.log(response.data.data);
            this.setState({
                loading:false,
                okrLists: response.data.data
            })


            setTimeout(function(){

                $('#BBIRTable').DataTable( {
                    searching: false,
                    bInfo : false,
                    paging: false,
                    "bSort": false,
                    "responsive": false,
                    "scrollX": true,

                } );

            }, 200);
        });
    }

    okr_report_download (e){
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            user_type: this.state.uTypeIDs,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            download: true
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/login-report-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = timestamp+'User_Login_Report.csv';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    render() {
        const okrBody = this.state.okrLists.map((data, index) => {
            var rowClass = "";
            if(data.highlight===true){
                rowClass = "hightlight-row";
            }

            return (
                <tr key={index} className={rowClass}>
                    <td>{data['OKR No.']}</td>
                    <td>{data['OKR']}</td>
                    <td>{data['By When']}</td>
                    <td>{data['Responsibility']}</td>
                    <td>{data['Achieved']}</td>
                    <td>{data['Value Impact Calculations']}</td>
                    <td>{data['Value Target Recurring (in Rs. Lacs)']}</td>
                    <td>{data['Value Target One Time (in Rs. Lacs)']}</td>
                    <td>{data['Value Achieved Recurring (in Rs. Lacs)']}</td>
                    <td>{data['Value Achieved One Time (in Rs. Lacs)']}</td>


                </tr>
            )
        });




        return(
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">OKR Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {/*<div className="">*/}
                                    {/*    <a href="#" className="exportButton" role="button" onClick={this.okr_report_download.bind(this)}>*/}
                                    {/*        <i className="fa fa-download" aria-hidden="true"></i>*/}
                                    {/*        Export to CSV*/}
                                    {/*    </a>*/}
                                    {/*</div>*/}
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="acqFallBackTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>OKR No.</th>
                                                    <th>OKR</th>
                                                    <th>By When</th>
                                                    <th>Responsibility</th>
                                                    <th>Achieved</th>
                                                    <th>Value Impact Calculations</th>
                                                    <th>Value Target Recurring (in Rs. Lacs)</th>
                                                    <th>Value Target One Time (in Rs. Lacs)</th>
                                                    <th>Value Achieved Recurring (in Lacs</th>
                                                    <th>Value Achieved One Time (in Lacs</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {okrBody}
                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(OkrReport)